import { React, useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  RightLayoutContainer,
  PageTitleComp,
  DetailFields,
  DownArrowDraw,
  DropDownSearchDraw,
} from "../../styledElements";
import styled from "styled-components";
import { Styled, DatePickerY, DisabledButtonStyle } from "../../pageStyled";
import Iconmoon from "../../../Components/IconsFiles/icon";
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  Select,
  PageHeader,
  Checkbox,
  Tooltip,
} from "antd";
import { HaberForm } from "../../styledElements";
import { useWindowDimensions } from "../../../hooks/useWindowDimensions";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import {
  getAllGrades,
  getGradeQualities,
  getGradeProductParameter,
} from "../../../Services/settingsServices";
import { saveUploadedProducts } from "../../../Services/uploadServices";
import { getUnitData } from "../../../Services/measurementService";
import { weightUnit } from "../../../Utils/Constant/MeasurementUnitList";
import { FixedSizeList } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
const { Option } = Select;

const { TextArea } = Input;
export const HeaderStyle = styled.div`
  .labelStyle {
    font-size: 14px;
    color: var(--para-text);
    font-family: var(--sf-pro-text);
    padding-left: 7px;
  }
`;

  const RowData = ({ index, style, data }) => {
    let styleValue = {};
    let multiplyValue = index == 1 ? 2 : 15;
    styleValue["width"] = style.width;
    delete styleValue["height"];
    // styleValue["marginTop"] = "5px";
    styleValue["position"] = style.position;
    styleValue["top"] = style.top - multiplyValue * index;
    // styleValue["top"] = index == 0 ? style.top : index == 1 ? 100 : style.top - (2 * (index - 2));

    const {
      products,
      rowCount,
      grades,
      types,
      unitData,
      setRowCount,
      onGSMChange,
      onGradeChange,
      onQualityChnage,
      onTypeChange,
      onBulkChange, 
      onBustFactorChange, 
      onMoistureChange, 
      onRemarksChange, 
      onReferenceIdChange, 
      onPriceChange,
      onCurrencyChange, 
      onPlyChange,
      onUnitPerWeightChange,
    } = data;

    return (
      index !== undefined && (
        <div style={styleValue}>
          <Row
            gutter={[9, 9]}
            className="groupForm"
            style={{
              width: "4500px",
              paddingBottom: products[index]?.error_count ? "-3px" : "23px",
              paddingTop: products[index]?.error_count ? "" : "8px",
              marginBottom: products[index]?.error_count ? "5px" : "15px",
            }}
          >
            {/* <Col style={{ paddingTop: index == 0 ? "40px" : "10px" }}>
                {(products[index].error_count || products[index].errors.hasOwnProperty(products[index])) ? (
                  <Iconmoon icon="wrong" size={14} color="#EA655B" />
                ) : (
                  <div style={{ width: "14px" }}></div>
                )
                }
              </Col> */}
            <Col
              style={{
                paddingTop: index == 0 ? "40px" : "10px",
                paddingTop: "10px",
                width: "17px",
              }}
            >
              <Styled>
                {/* {(products[index].error_count || products[index].errors.hasOwnProperty(products[index])) && */}
                <Tooltip
                  placement="bottomRight"
                  title={
                    products[index].error_count ||
                    products[index].errors.hasOwnProperty(products[index])
                      ? "This product has failed validation"
                      : ""
                  }
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <div style={{ cursor: "default" }}>
                    {products[index].error_count ||
                    products[index].errors.hasOwnProperty(products[index]) ? (
                      <Iconmoon icon="wrong" size={14} color="#EA655B" />
                    ) : (
                      <div style={{ width: "14px" }}></div>
                    )}
                  </div>
                </Tooltip>
                {/* } */}
              </Styled>
            </Col>
            <Col style={{ width: "60px" }}>
              <div className="boxFormType">
                <Form.Item
                  label={index == 0 || !rowCount.current ? "S.No." : ""}
                  name={`sno${index}`}
                  rules={[]}
                  className="dBlock"
                  initialValue={index + 1}
                >
                  <Input
                    disabled={true}
                    style={{ textTransform: "capitalize" }}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col style={{ width: "190px" }}>
              <div className="boxFormType">
                <Form.Item
                  label={index == 0 ? "Product Name" : ""}
                  name={`name${index}`}
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                    },
                  ]}
                  className="dBlock"
                  initialValue={products[index].product.name}
                >
                  <Input
                    placeholder="Enter Product Name"
                    style={{ textTransform: "capitalize" }}
                    disabled
                  />
                </Form.Item>
              </div>
              {products[index].errors.hasOwnProperty("name") ? (
                <span className="errorText" style={{ color: "#ea4e2c" }}>
                  {products[index].errors.name}
                </span>
              ) : null}
            </Col>
            <Col style={{ width: "120px" }}>
              <div className="boxFormType">
                <Form.Item
                  label={index == 0 ? "Type" : ""}
                  name={`type${index}`}
                  rules={[{ required: true, message: "Type is required" }]}
                  validateStatus={products[index].errors?.type ? "error" : ""}
                  help={products[index].errors?.type}
                  initialValue={products[index].product.type}
                  className="dBlock"
                >
                  <Select
                    suffixIcon={<DownArrowDraw />}
                    onChange={(e) => onTypeChange(e, index)}
                    placeholder="Select Type"
                  >
                    {types.map((type) => (
                      <Option key={type.value} value={type.value}>
                        {type.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
            </Col>

            <Col style={{ width: "170px" }}>
              <div className="boxFormType">
                <Form.Item
                  label={index == 0 ? "Ply Range" : ""}
                  name={`ply${index}`}
                  rules={[
                    { required: true, message: "Select at least one ply" },
                  ]}
                  validateStatus={products[index].errors?.ply ? "error" : ""}
                  help={products[index].errors?.ply}
                  initialValue={products[index].product?.ply?.map(String)}
                  className="dBlock"
                >
                  <Checkbox.Group
                    onChange={(e) => onPlyChange(e, index)}
                    disabled={products[index].product.type === "sheet"}
                    value={
                      products[index].product.type === "sheet"
                        ? ["1"]
                        : products[index].product.ply.map(String)
                    }
                  >
                    <Row gutter={[0, 4]}>
                      {(products[index].product.type === "sheet"
                        ? [1]
                        : [1, 2, 3, 4]
                      ).map((ply) => (
                        <Col span={24} key={ply}>
                          <Checkbox value={ply.toString()}>
                            {ply === 1
                              ? "Single Ply"
                              : ply === 2
                              ? "Double Ply"
                              : ply === 3
                              ? "3-Ply"
                              : "4-Ply"}
                          </Checkbox>
                        </Col>
                      ))}
                    </Row>
                  </Checkbox.Group>
                </Form.Item>
              </div>
            </Col>

            <Col style={{ width: "190px" }}>
              <div className="boxFormType">
                <Form.Item
                  label={index == 0 ? "Grade" : ""}
                  name={`grade${index}`}
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                    },
                  ]}
                  className="dBlock"
                  initialValue={products[index].product.grade}
                  // validateStatus={products[index].errors.hasOwnProperty('product') ? "error" : null}
                  // help={products[index].errshowSearchsaors.hasOwnProperty('product') ? products[index].errors.product : null}
                >
                  <Select
                    suffixIcon={<DownArrowDraw />}
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    placeholder={"Select a grade"}
                    onChange={(e) => {
                      onGradeChange(e, index);
                    }}
                  >
                    {grades?.map((grade) => (
                      <Option key={grade}>{grade}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
              {products[index].errors.hasOwnProperty("grade") ? (
                <span className="errorText" style={{ color: "#ea4e2c" }}>
                  {products[index].errors.grade}
                </span>
              ) : null}
            </Col>
            <Col style={{ width: "120px" }}>
              <div className="boxFormType">
                <Form.Item
                  label={index == 0 ? "GSM" : ""}
                  name={`gms${index}`}
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                    },
                    {
                      pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
                      message: "Only numeric characters are allowed",
                    },
                    // {
                    //   max: 4,
                    //   message:
                    //     "GSM cannot be more than four characters",
                    // },
                    {
                      validator: (_, value) => {
                        if (parseInt(value) > 9999) {
                          return Promise.reject(
                            "GSM cannot be more than four characters"
                          );
                        } else {
                          return Promise.resolve();
                        }
                      },
                    },
                  ]}
                  initialValue={
                    products[index].product.gsm
                      ? products[index].product.gsm
                      : undefined
                  }
                  className="dBlock"
                >
                  <Input
                    onChange={(e) => {
                      onGSMChange(e, index);
                    }}
                    placeholder="Enter GSM of the product"
                  />
                </Form.Item>
              </div>
              {products[index].errors.hasOwnProperty("gsm") ? (
                <span className="errorText" style={{ color: "#ea4e2c" }}>
                  {products[index].errors.gsm}
                </span>
              ) : null}
            </Col>
            {/* { products[index]?.product?.productParam?.product?.burst_factor && (<Col style={{ width: "100px" }}>
                          <div className="boxFormType">
                            <Form.Item
                              label={index == 0 ? "BF" : ""}
                              name={`burst_factor${index}`}
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                                {
                                  pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
                                  message: "Only numeric characters are allowed",
                                },
                              ]}
                              initialValue={products[index].product.burst_factor ? products[index].product.burst_factor : undefined}
                              className="dBlock"
                            >
                              <Input
                                onChange={(e) => {
                                  onBustFactorChange(e, index);
                                }}
                                placeholder="Enter Burst Factor of the product"
                              />
                            </Form.Item>
                          </div>
                          {products[index].errors.hasOwnProperty("burst_factor") ? (
                            <span
                              className="errorText"
                              style={{ color: "#ea4e2c" }}
                            >
                              {products[index].errors.burst_factor}
                            </span>
                          ) : null}
                        </Col>)} */}
            <Col style={{ width: "100px" }}>
              <div className="boxFormType">
                <Form.Item
                  label={index == 0 ? "BF" : ""}
                  name={`burst_factor${index}`}
                  rules={
                    products[index]?.product?.productParam?.product
                      ?.burst_factor ||
                    (products[index]?.product?.productParam &&
                      !products[index]?.product?.productParam.product)
                      ? [
                          {
                            required: true,
                            message: "This field is required",
                          },
                          {
                            pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
                            message: "Only numeric characters are allowed",
                          },
                        ]
                      : []
                  }
                  initialValue={
                    products[index].product.burst_factor
                      ? products[index].product.burst_factor
                      : undefined
                  }
                  className="dBlock"
                >
                  <Input
                      onChange={(e) => {
                        onBustFactorChange(e, index);
                      }}
                      placeholder="Enter Burst Factor of the product"
                    />
                  {/* {products[index]?.product?.productParam?.product
                    ?.burst_factor ||
                  (products[index]?.product?.productParam &&
                    !products[index]?.product?.productParam.product) ? (
                    <Input
                      onChange={(e) => {
                        onBustFactorChange(e, index);
                      }}
                      placeholder="Enter Burst Factor of the product"
                    />
                  ) : (
                    <span style={{ textAlign: "center", display: "block" }}>
                      NA
                    </span>
                  )} */}
                </Form.Item>
              </div>
              {products[index].errors.hasOwnProperty("burst_factor") ? (
                <span className="errorText" style={{ color: "#ea4e2c" }}>
                  {products[index].errors.burst_factor}
                </span>
              ) : null}
            </Col>
            <Col style={{ width: "100px" }}>
              <div className="boxFormType">
                <Form.Item
                  label={index == 0 ? "Bulk" : ""}
                  name={`bulk${index}`}
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                    },
                    {
                      pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
                      message: "Only numeric characters are allowed",
                    },
                  ]}
                  initialValue={
                    products[index].product.bulk
                      ? products[index].product.bulk
                      : undefined
                  }
                  className="dBlock"
                >
                  <Input
                    onChange={(e) => {
                      onBulkChange(e, index);
                    }}
                    placeholder="Enter bulk of the product"
                  />
                </Form.Item>
              </div>
              {products[index].errors.hasOwnProperty("bulk") ? (
                <span className="errorText" style={{ color: "#ea4e2c" }}>
                  {products[index].errors.bulk}
                </span>
              ) : null}
            </Col>
            <Col style={{ width: "100px" }}>
              <div className="boxFormType">
                <Form.Item
                  label={index == 0 ? "Moisture" : ""}
                  name={`moisture${index}`}
                  rules={
                    products[index]?.product?.productParam?.product?.moisture
                      ? [
                          {
                            required: true,
                            message: "This field is required",
                          },
                          {
                            pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
                            message: "Only numeric characters are allowed",
                          },
                        ]
                      : []
                  }
                  initialValue={
                    products[index].product.moisture
                      ? products[index].product.moisture
                      : null
                  }
                  className="dBlock"
                >
                    <Input
                      onChange={(e) => {
                        onMoistureChange(e, index);
                      }}
                      placeholder="Enter moisture of the product"
                    />
                  {/* {products[index]?.product?.productParam?.product?.moisture ? (
                    <Input
                      onChange={(e) => {
                        onMoistureChange(e, index);
                      }}
                      placeholder="Enter moisture of the product"
                    />
                  ) : (
                    <span style={{ textAlign: "center", display: "block" }}>
                      NA
                    </span>
                  )} */}
                </Form.Item>
              </div>
              {products[index].errors.hasOwnProperty("moisture") ? (
                <span className="errorText" style={{ color: "#ea4e2c" }}>
                  {products[index].errors.moisture}
                </span>
              ) : null}
            </Col>
            <Col style={{ width: "190px" }}>
              <div className="boxFormType">
                <Form.Item
                  label={index == 0 ? "Quality" : ""}
                  name={`quality${index}`}
                  rules={[
                    {
                      required:
                        true &&
                        products[index]?.product?.qualityList?.length !== 0,
                      message: "Please select a quality",
                    },
                  ]}
                  initialValue={
                    products[index].product.quality
                      ? products[index].product.quality
                      : undefined
                  }
                  className="dBlock"
                >
                  <Select
                    suffixIcon={<DownArrowDraw />}
                    //   onBlur = {OntoggleSelect}
                    //   onFocus = {OntoggleSelect}
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    placeholder={"Select a quality"}
                    onChange={(e) => {
                      onQualityChnage(e, index);
                    }}
                    //disabled={!selectGradeType}
                  >
                    {products[index]?.product?.qualityList?.map(
                      (qualityType) => (
                        <Option key={qualityType}>{qualityType}</Option>
                      )
                    )}
                  </Select>
                </Form.Item>
              </div>
              {products[index].errors.hasOwnProperty("quality") ? (
                <span className="errorText" style={{ color: "#ea4e2c" }}>
                  {products[index].errors.quality}
                </span>
              ) : null}
            </Col>
            <Col style={{ width: "100px" }}>
              <div className="boxFormType">
                <Form.Item
                  label={index == 0 ? "Currency" : ""}
                  name={`currency${index}`}
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "This field is required",
                  //   },
                  // ]}
                  className="dBlock"
                  initialValue={products[index].product.units.currency}
                  // validateStatus={products[index].errors.hasOwnProperty('product') ? "error" : null}
                  // help={products[index].errshowSearchsaors.hasOwnProperty('product') ? products[index].errors.product : null}
                >
                  <Select
                    suffixIcon={<DownArrowDraw />}
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    placeholder={"Select a currency"}
                    onChange={(e) => {
                      onCurrencyChange(e, index);
                    }}
                  >
                    {unitData?.units_management?.currency?.data?.map(
                      (currency) => (
                        <Option key={currency}>{currency}</Option>
                      )
                    )}
                  </Select>
                </Form.Item>
              </div>
              {products[index].errors.hasOwnProperty("currency") ? (
                <span className="errorText" style={{ color: "#ea4e2c" }}>
                  {products[index].errors.currency}
                </span>
              ) : null}
            </Col>
            <Col style={{ width: "150px" }}>
              <div className="boxFormType unitSelect">
                <Form.Item
                  label={index == 0 ? "Price" : ""}
                  name={`price${index}`}
                  rules={[
                    // {
                    //   required: true,
                    //   message: "This field is required",
                    // },
                    {
                      pattern: /^\d+(\.\d{1,3})?$|^\.\d{1,3}$/,
                      message: "Only decimal characters upto 3 decimal places are allowed",
                    },
                  ]}
                  initialValue={products[index].product.price}
                  className="dBlock"
                >
                  <Input
                    onChange={(e) => {
                      onPriceChange(e, index);
                    }}
                    placeholder="Enter price of product in Price/Ton"
                  />
                </Form.Item>
              </div>
              {products[index].errors.hasOwnProperty("price") ? (
                <span className="errorText" style={{ color: "#ea4e2c" }}>
                  {products[index].errors.price}
                </span>
              ) : null}
            </Col>
            <Col style={{ width: "100px" }}>
              <div className="boxFormType">
                <Form.Item
                  label={index == 0 ? "Per Weight" : ""}
                  name={`weight${index}`}
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "This field is required",
                  //   },
                  // ]}
                  className="dBlock"
                  initialValue={products[index].product.units.per_weight_unit}
                  // validateStatus={products[index].errors.hasOwnProperty('product') ? "error" : null}
                  // help={products[index].errshowSearchsaors.hasOwnProperty('product') ? products[index].errors.product : null}
                >
                  <Select
                    suffixIcon={<DownArrowDraw />}
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    placeholder={"Select a Per Weight"}
                    onChange={(e) => {
                      onUnitPerWeightChange(e, index);
                    }}
                  >
                    {unitData?.units_management?.weight?.data?.map((weight) => (
                      <Option key={weight}>
                        {weightUnit[weight].displayName}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
              {products[index].errors.hasOwnProperty("per_weight_unit") ? (
                <span className="errorText" style={{ color: "#ea4e2c" }}>
                  {products[index].errors.per_weight_unit}
                </span>
              ) : null}
            </Col>
            <Col style={{width:"190px"}}>
              <div className="boxFormType">
                <Form.Item
                  label={index == 0 ? "Remarks" : ""}
                  name={`remarks${index}`}
                  rules={[
                    {
                      max: 70,
                      message: "Remarks can have a maximum of 70 characters",
                    },
                  ]}
                  initialValue={products[index].product.remarks}
                  className="dBlock"
                >
                  <TextArea
                    placeholder="Remarks"
                    onChange={(e) => {
                      onRemarksChange(e, index);
                    }}
                    style={{ height: "40px" }}
                  />
                </Form.Item>
              </div>
              {products[index].errors.hasOwnProperty("remarks") ? (
                <span className="errorText" style={{ color: "#ea4e2c" }}>
                  {products[index].errors.remarks}
                </span>
              ) : null}
            </Col>
            {[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15].map((i)=>(<Col key={i} style={{width:"170px"}}>
              <div className="boxFormType">
                <Form.Item
                  label={index == 0 ? `Reference Code ${i}` : ""}
                  name={`reference_id_${i}_${index}`}
                  rules={[
                    {
                      pattern: /^[a-zA-Z0-9 ]+$/,
                      message: "Reference Code can be only alphanumeric!",
                    },
                  ]}
                  initialValue={products[index].product[`reference_id_${i}`]}
                  className="dBlock"
                >
                  <Input
                    placeholder={`Reference Code ${i}`}
                    onChange={(e) => {
                      onReferenceIdChange(i,e, index);
                    }}
                    style={{ height: "40px" }}
                  />
                </Form.Item>
              </div>
              {products[index].errors.hasOwnProperty(`reference_id_${i}`) ? (
                <span className="errorText" style={{ color: "#ea4e2c" }}>
                  {products[index].errors[`reference_id_${i}`]}
                </span>
              ) : null}
            </Col>))}
            {setRowCount()}
          </Row>
        </div>
      )
    );
  };

const ProductValidation = (props) => {
  const location = useLocation();
  const history = useNavigate();
  const [form] = Form.useForm();
  const [products, setProducts] = useState();
  const [totalRecords, setTotalRecords] = useState(
    location.state.action.data.products
  );
  const [visibleToaster, setVisibleToaster] = useState(false);
  const [show, setShow] = useState(false);
  const [grades, setGrades] = useState([]);
  const rowCount = useRef(false);
  const [actionToaster, setActionToaster] = useState({
    error: "",
    msg: "",
  });
  const { height, width } = useWindowDimensions();
  const [rerendering, setRerendering] = useState(false);
  const [unitData, setUnitData] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      await getAllGrades("enabled")
        .then((response) => {
          setGrades(response.map((grade) => grade.name));
          getUnitData()
            .then((response) => {
              setUnitData(response.data);
            })
            .catch((error) => {
              console.log(error);
            });
          // console.log("Grades", grades);
        })
        .catch((error) => {
          console.log(error);
        });
      let changedProducts = [];
      for (
        let index = 0;
        index < location?.state?.action?.data?.products?.length;
        index++
      ) {
        let product = location?.state?.action?.data?.products[index];
        product["key"] = `${product.product.name + index}`;
        if (!product.errors.grade) {
          product.product["qualityList"] = product?.product?.qualities?.map(
            (quality) => quality.name
          );
          let prodParam = {};
          prodParam["product"] = product?.product?.product_parameters;
          product.product["productParam"] = prodParam;
          //   await getGradeQualities(
          //     encodeURIComponent(product.product.grade),
          //     "enabled"
          //   )
          //     .then((response) => {
          //       product.product["qualityList"] = response.map(
          //         (quality) => quality.name
          //       );
          //     })
          //     .catch((error) => {
          //       console.log(error);
          //       product.product["qualityList"] = [];
          //     });
          //     await getGradeProductParameter(product.product.grade)
          //   .then((response) => {
          //   product.product['productParam'] = response;
          // })
          // .catch((error) => {
          //   console.log(error);
          // });
        } else {
          product.product["qualityList"] = [];
          product.product["productParam"] = {
            product: {
              bulk: true,
              moisture: true,
            },
          };
        }
        changedProducts.push(product);
      }
      setProducts(changedProducts);
      setTotalRecords(changedProducts);
      form.setFields([{
        name: 'reference_id_1_1',
        value: 'RAHUL',
        errors: ["this is required!"]
      }])
    })();
  }, []);
  const saveDetails = () => {
    form.submit();
  };

  const onFinish = () => {
    const finalProducts = totalRecords.map((product) => {
      delete product.key;
      delete product.product.qualityList;
      product.product.gsm = parseFloat(product.product.gsm);
      product.product.price = parseFloat(product.product.price);
      product.product.bulk = parseFloat(product.product.bulk);

      product.product.units["price"] = product.product.units.currency ? product.product.units.currency : product.product.units.price;
      delete product.product.units.currency;

      if (product.product.burst_factor)
        product.product.burst_factor = parseFloat(product.product.burst_factor);

      if (product.product.moisture)
        product.product.moisture = parseFloat(product.product.moisture);

      product.product.name =
        product.product.name.trim().charAt(0).toUpperCase() +
        product.product.name.trim().slice(1);

      if (
        !product.product.productParam?.product?.moisture &&
        product.product.moisture
      ) {
        delete product.product.moisture;
      }
      if (
        product.product.productParam?.product &&
        !product.product.productParam?.product?.burst_factor &&
        product.product.burst_factor
      ) {
        delete product.product.burst_factor;
      }

      delete product.product.productParam;

      return product;
    });
    const body ={
      file_name: location.state.filename?.split("/").pop() ?? "",
      products_data: finalProducts,
      total_products: finalProducts.length,
      successful_products: products.length - totalRecords.filter((item) => item.error_count > 0).length,
    }
    // console.log(body);
    saveUploadedProducts(body)
      .then((response) => {
        setActionToaster({
          error: response.error,
          msg: "Products are successfully uploaded",
        });
        showToaster();
        setTimeout(() => {
          history("../products-records", {
            state: {},
          });
        }, 2000);
        form.resetFields();
      })
      .catch((error) => {
        // setActionToaster({
        //   error: error.response.data.error,
        //   msg: "Products are not saved",
        // });
        // showToaster();
        if(error?.response?.status == 500){
          setActionToaster({
            error: true,
            msg: "Something went wrong. Please try again",
          });
        } else{
            setActionToaster({
              error: true,
              msg: error?.response?.data?.msg,
            });      
        }
      showToaster();
      });
  };

  const setRowCount = () => {
    rowCount.current = true;
  };

  const onGradeChange = async (e, index) => {
    form.setFieldsValue({
      [`quality${index}`]: "",
    });
    let productsData = [...products];
    productsData[index].product.grade = e;
    productsData[index].product.quality = "";
    if (productsData[index].errors.grade) {
      delete productsData[index].errors.grade;
      productsData[index].error_count = productsData[index].error_count - 1;
    }
    if (productsData[index].errors.quality) {
      delete productsData[index].errors.quality;
      productsData[index].error_count = productsData[index].error_count - 1;
    }
    // await getGradeQualities(encodeURIComponent(e), "enabled")
    //   .then((response) => {
    //     productsData[index].product["qualityList"] = response.map(
    //       (quality) => quality.name
    //     );
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //     productsData[index].product["qualityList"] = [];
    //   });
    await getGradeProductParameter(e)
      .then((response) => {
        let enabledQualities = response.qualities.filter(
          (quality) => quality.value
        );
        console.log(enabledQualities);
        productsData[index].product["qualityList"] = enabledQualities.map(
          (item) => item.name
        );
        if (
          ((response && !Object.keys(response).length) ||
            !response?.product?.moisture) &&
          productsData[index].product.moisture
        ) {
          productsData[index].product.moisture = 0;
          if (productsData[index].errors.moisture) {
            delete productsData[index].errors.moisture;
            productsData[index].error_count =
              productsData[index].error_count - 1;
          }
        }
        if (
          !response?.product?.burst_factor &&
          productsData[index].product.burst_factor
        ) {
          productsData[index].product.burst_factor = 0;
          if (productsData[index].errors.burst_factor) {
            delete productsData[index].errors.burst_factor;
            productsData[index].error_count =
              productsData[index].error_count - 1;
          }
        }
        productsData[index].product["productParam"] = response;
      })
      .catch((error) => {
        console.log(error);
      });
    let totalRecordsData = [...totalRecords];
    let totalProductIndex = totalRecordsData.findIndex(function (data, i) {
      return data.key === productsData[index].key;
    });

    totalRecordsData[totalProductIndex] = { ...productsData[index] };
    setTotalRecords(totalRecordsData);
    setProducts(productsData);
    setRerendering(true);
  };

  const onBustFactorChange = (e, index) => {
    let productsData = [...products];

    if (productsData[index].errors.burst_factor) {
      delete productsData[index].errors.burst_factor;
      productsData[index].error_count = productsData[index].error_count - 1;
    }
    productsData[index].product.burst_factor = e.target.value;
    let totalRecordsData = [...totalRecords];
    let totalProductIndex = totalRecordsData.findIndex(function (data, i) {
      return data.key === productsData[index].key;
    });
    totalRecordsData[totalProductIndex] = { ...productsData[index] };
    setTotalRecords(totalRecordsData);
    setProducts(productsData);
  };

  const onBulkChange = (e, index) => {
    let productsData = [...products];

    if (productsData[index].errors.bulk) {
      delete productsData[index].errors.bulk;
      productsData[index].error_count = productsData[index].error_count - 1;
    }
    productsData[index].product.bulk = e.target.value;
    let totalRecordsData = [...totalRecords];
    let totalProductIndex = totalRecordsData.findIndex(function (data, i) {
      return data.key === productsData[index].key;
    });
    totalRecordsData[totalProductIndex] = { ...productsData[index] };
    setTotalRecords(totalRecordsData);
    setProducts(productsData);
  };

  const onMoistureChange = (e, index) => {
    let productsData = [...products];

    if (productsData[index].errors.moisture) {
      delete productsData[index].errors.moisture;
      productsData[index].error_count = productsData[index].error_count - 1;
    }
    productsData[index].product.moisture = e.target.value;
    let totalRecordsData = [...totalRecords];
    let totalProductIndex = totalRecordsData.findIndex(function (data, i) {
      return data.key === productsData[index].key;
    });
    totalRecordsData[totalProductIndex] = { ...productsData[index] };
    setTotalRecords(totalRecordsData);
    setProducts(productsData);
  };

  const onGSMChange = (e, index) => {
    let productsData = [...products];

    if (productsData[index].errors.gsm) {
      delete productsData[index].errors.gsm;
      productsData[index].error_count = productsData[index].error_count - 1;
    }
    productsData[index].product.gsm = e.target.value;
    let totalRecordsData = [...totalRecords];
    let totalProductIndex = totalRecordsData.findIndex(function (data, i) {
      return data.key === productsData[index].key;
    });
    totalRecordsData[totalProductIndex] = { ...productsData[index] };
    setTotalRecords(totalRecordsData);
    setProducts(productsData);
  };

  const onQualityChnage = (e, index) => {
    let productsData = [...products];

    if (productsData[index].errors.quality) {
      delete productsData[index].errors.quality;
      productsData[index].error_count = productsData[index].error_count - 1;
    }
    productsData[index].product.quality = e;
    let totalRecordsData = [...totalRecords];
    let totalProductIndex = totalRecordsData.findIndex(function (data, i) {
      return data.key === productsData[index].key;
    });
    totalRecordsData[totalProductIndex] = { ...productsData[index] };
    setTotalRecords(totalRecordsData);
    setProducts(productsData);
  };

  const onPriceChange = (e, index) => {
    let productsData = [...products];

    if (productsData[index].errors.price) {
      delete productsData[index].errors.price;
      productsData[index].error_count = productsData[index].error_count - 1;
    }
    productsData[index].product.price = e.target.value;
    let totalRecordsData = [...totalRecords];
    let totalProductIndex = totalRecordsData.findIndex(function (data, i) {
      return data.key === productsData[index].key;
    });
    totalRecordsData[totalProductIndex] = { ...productsData[index] };
    setTotalRecords(totalRecordsData);
    setProducts(productsData);
  };

  const onRemarksChange = (e, index) => {
    let productsData = [...products];

    if (productsData[index].errors["remarks"]) {
      delete productsData[index].errors["remarks"];
      productsData[index].error_count = productsData[index].error_count - 1;
    }
    productsData[index].product["remarks"] = e.target.value;
    let totalRecordsData = [...totalRecords];
    let totalProductIndex = totalRecordsData.findIndex(function (data, i) {
      return data.key === productsData[index].key;
    });
    totalRecordsData[totalProductIndex] = { ...productsData[index] };
    setTotalRecords(totalRecordsData);
    setProducts(productsData);
  };

  const onReferenceIdChange = (i, e, index) => {
    const value = e.target.value;

    const newProducts = [...products];

    const updatedProduct = { ...newProducts[index] };

    if (updatedProduct.errors?.hasOwnProperty(`reference_id_${i}`)) {
      const newErrors = { ...updatedProduct.errors };
      delete newErrors[`reference_id_${i}`];

      updatedProduct.errors = newErrors;
      updatedProduct.error_count -= 1;
    }

    updatedProduct.product = {
      ...updatedProduct.product,
      [`reference_id_${i}`]: value
    };

    newProducts[index] = updatedProduct;

    setProducts(newProducts);
    setTotalRecords(newProducts);
  };

  const filterRecords = (filterParam) => {
    let failedProducts = totalRecords.filter((item) =>
      filterParam ? item.error_count > 0 : item
    );
    setProducts(failedProducts);
    setRerendering(true);
  };

  const onCurrencyChange = (e, index) => {
    let productsData = [...products];

    if (productsData[index].errors.currency) {
      delete productsData[index].errors.currency;
      productsData[index].error_count = productsData[index].error_count - 1;
    }
    productsData[index].product.units.currency = e;
    let totalRecordsData = [...totalRecords];
    let totalProductIndex = totalRecordsData.findIndex(function (data, i) {
      return data.key === productsData[index].key;
    });
    totalRecordsData[totalProductIndex] = { ...productsData[index] };
    setTotalRecords(totalRecordsData);
    setProducts(productsData);
  };

  const onUnitPerWeightChange = (e, index) => {
    let productsData = [...products];

    if (productsData[index].errors.per_weight_unit) {
      delete productsData[index].errors.per_weight_unit;
      productsData[index].error_count = productsData[index].error_count - 1;
    }
    productsData[index].product.units.per_weight_unit = e;
    let totalRecordsData = [...totalRecords];
    let totalProductIndex = totalRecordsData.findIndex(function (data, i) {
      return data.key === productsData[index].key;
    });
    totalRecordsData[totalProductIndex] = { ...productsData[index] };
    setTotalRecords(totalRecordsData);
    setProducts(productsData);
  };

  const handleScroll = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };
  const types = [
    { label: "Reel", value: "reel" },
    { label: "Sheet", value: "sheet" },
    { label: "Reel & Sheet", value: "both" },
  ];

  const onTypeChange = (value, index) => {
    const updated = [...products];
    updated[index].product.type = value;

    // Clear type error if it exists
    if (updated[index].errors?.type) {
      delete updated[index].errors.type;
      updated[index].error_count = updated[index].error_count - 1;
    }

    // Adjust ply options dynamically
    if (value === "sheet") {
      updated[index].product.ply = [1]; // Only 1 is valid
    } else if (
      !updated[index].product.ply ||
      updated[index].product.ply.length === 0
    ) {
      updated[index].product.ply = [];
    }

    setProducts(updated);
    updateTotalRecord(index, updated[index]);
    setRerendering(true); // In case form needs reset to remove red border
  };

  const onPlyChange = (selectedValues, index) => {
    const updated = [...products];
    updated[index].product.ply = selectedValues.map(Number); // Ensure it's numbers

    // Clear ply error if exists
    if (updated[index].errors?.ply) {
      delete updated[index].errors.ply;
      updated[index].error_count = updated[index].error_count - 1;
    }

    setProducts(updated);
    updateTotalRecord(index, updated[index]);
  };

  const updateTotalRecord = (index, newProduct) => {
    const totalCopy = [...totalRecords];
    const findIndex = totalCopy.findIndex((p) => p.key === newProduct.key);
    if (findIndex !== -1) totalCopy[findIndex] = { ...newProduct };
    setTotalRecords(totalCopy);
  };

  useEffect(() => {
    if (rerendering) {
      form.resetFields();
      setRerendering(false);
    }
  }, [rerendering]);
  const showToaster = () => {
    setVisibleToaster(true);
    setTimeout(() => setVisibleToaster(false), 2000);
  };

  const itemData = {
    products,
    rowCount,
    types,
    grades,
    unitData,
    setRowCount,
    onGSMChange,
    onGradeChange,
    onBulkChange,
    onBustFactorChange,
    onMoistureChange,
    onQualityChnage,
    onTypeChange,
    onPlyChange,
    onReferenceIdChange,
    onRemarksChange,
    onCurrencyChange,
    onPriceChange,
    onUnitPerWeightChange,
  }

  return (
    // products && unitData ?
    // (
    <RightLayoutContainer style={{ overflow: "hidden" }}>
      <PageTitleComp
        className="marginRightAdg"
        style={{ marginBottom: "12px" }}
      >
        <PageHeader
          title="Upload Result"
          extra={[
            <Button
              key="3"
              className="themeBtn noBg"
              onClick={() => {
                history("../products-records/upload-products", {
                  state: { action: products },
                });
                form.resetFields();
              }}
            >
              <Iconmoon icon="left-to-thin" size={14} color="#EA655B" />
              Upload Again
            </Button>,
            <Button
              key="1"
              className="themeBtn"
              onClick={() => saveDetails()}
              disabled={
                totalRecords.filter((e) => e.error_count > 0).length > 0
              }
            >
              <Iconmoon icon="addcircle" size={14} color="#ffff" />
              Save Products
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>

      <div
        className="showPriorityOrder"
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "10px",
          flexDirection: "row-reverse",
        }}
      >
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div>
            <DisabledButtonStyle style={{ displayFlex: "end" }}>
              <Button
                className={
                  show
                    ? "themeBtn noBg approveAllOrders"
                    : "themeBtn noBg disabledstyle approve-header"
                }
                onClick={() => {
                  setShow(!show);
                  filterRecords(!show);
                  rowCount.current = false;
                }}
              >
                <Iconmoon icon="filter" size={16} color="#605E5C" />{" "}
                {show ? "Show All Products" : "Show Only Failed Products"}
              </Button>
            </DisabledButtonStyle>
          </div>
          <div
            style={{
              marginTop: "10px",
              marginRight: "15px",
              fontSize: "14px",
              fontFamily: "var(--sf-pro-display)",
              lineHeight: "16px",
            }}
          >
            Failed Products:{" "}
            {totalRecords.filter((e) => e.error_count > 0).length}
          </div>
          <div
            style={{
              marginTop: "10px",
              fontSize: "14px",
              fontFamily: "var(--sf-pro-display)",
              lineHeight: "16px",
            }}
          >
            Verified Products:{" "}
            {totalRecords.filter((e) => e.error_count == 0).length}
          </div>
        </div>
      </div>
      {/* <div style={{overflowX:'auto',background:'white',overflowY:'hidden',width:'103.5%'}} > */}
      <DetailFields>
        <HaberForm>
          <div className="groupDetailWrap">
            <Form
              form={form}
              name="basic"
              autoComplete="off"
              className="haberLogin"
              onFinish={onFinish}
            >
              {/* <div style={{width: "105%", position:"relative"}}>
                <HeaderStyle>
                {products?.length && <Row gutter={[9, 9]} style={{ width: "2000px", marginBottom:"3px"}}> 
                  <Col style={{width:"17px", paddingLeft:"7px"}}></Col>
                  <Col style={{ width:"60px", paddingLeft:"7px"}} className="labelStyle">S.No.</Col>
                  <Col span={3} className="labelStyle" style={{paddingLeft:"7px"}}>
                      <span style={{color:"red"}}>*</span>{" "}Product Name
                  </Col>
                  <Col span={3} className="labelStyle" style={{paddingLeft:"7px"}}>Grade</Col>
                  <Col span={1} className="labelStyle" style={{paddingLeft:"7px"}}>GSM</Col>
                  <Col className="labelStyle" style={{paddingLeft:"7px", width: "100px"}}>BF</Col>
                  <Col className="labelStyle" style={{paddingLeft:"7px", width: "100px"}}>Bulk</Col>
                  <Col className="labelStyle" style={{paddingLeft:"7px", width: "100px"}}>Moisture</Col>
                  <Col span={3} className="labelStyle" style={{paddingLeft:"7px"}}>Quality</Col>
                  <Col className="labelStyle" style={{paddingLeft:"7px", width: "100px"}}>Currency</Col>
                  <Col className="labelStyle" style={{paddingLeft:"7px", width: "150px"}}>Price</Col>
                  <Col className="labelStyle" style={{paddingLeft:"7px", width: "100px"}}>Per Weight</Col>
                  <Col span={3} className="labelStyle" style={{paddingLeft:"7px"}}>Remarks</Col>
                  </Row>}
                </HeaderStyle>
              </div> */}
              <div
                style={{ width: "105%", height: "900px", position: "relative" }}
              >
                <AutoSizer>
                  {({ height, width }) => (
                    <FixedSizeList
                      height={height}
                      itemCount={products?.length}
                      itemSize={160}
                      width={width}
                      overscanCount={2}
                      onScroll={handleScroll}
                      itemData={itemData}
                    >
                      {RowData}
                    </FixedSizeList>
                  )}
                </AutoSizer>
                {loading && (
                  <div style={{ position: "relative" }}>
                    <div style={{ marginTop: "33%", marginLeft: "2%" }}>
                      {"Loading..."}
                    </div>
                  </div>
                )}
              </div>
            </Form>
          </div>
        </HaberForm>
      </DetailFields>
      {/* </div> */}
      {/* Toasters */}

      {visibleToaster && !actionToaster.error && (
        <AlertContainer
          color="green toaster"
          icon={alertGreen}
          msg={actionToaster.msg}
        />
      )}
      {visibleToaster && actionToaster.error && (
        <AlertContainer
          color="red toaster"
          icon={alertRed}
          msg={actionToaster.msg}
        />
      )}
    </RightLayoutContainer>
  );
  // : null;
};

export default ProductValidation;